<template>
  <div class="login-page">
    <h1 v-if="showWelcomeBanner">Welcome to Azadi Academy!</h1>
    <div class="login-form">
      <h2>Login to the Azadi Academy</h2>
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label for="email">Email <span class="required">*</span></label>
          <input type="email" id="email" v-model="form.email" required />
        </div>
        <div class="form-group">
          <label for="password">Password <span class="required">*</span></label>
          <input
            type="password"
            id="password"
            v-model="form.password"
            required
          />
        </div>
        <div class="action-btn">
          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="!loading">Login</span>
            <span v-else class="loader"></span>
          </button>
        </div>
      </form>
      <p class="forgotlink">
        <!-- <router-link :to="'/forget-password'">Forgot password?</router-link> -->
        <router-link :to="{ path: '/register', query: { redirectTo: $route.query.redirectTo ? $route.query.redirectTo : ''  } }">Create new account</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    showWelcomeBanner: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions(["LogIn"]),
    async submitForm() {
      this.$emit("formsubmit");
      console.log(this.form);
      try {
          this.isSubmitted = true;
          if(this.form.email === '' || this.form.password === '') {
            return;
          }
          this.loading = true;
          await this.LogIn(this.form);
          const redirectTo = this.$route.query.redirectTo;
          if (redirectTo) {
            this.$router.push(decodeURIComponent(redirectTo));
          } else {
            this.$router.push("/home");
          }
          this.loading = false;
          this.showError = false
      } catch (error) {
        this.loading = false;
        console.log(error)
        this.showError = true
      }
      // Handle form submission logic (e.g., call login API)
    },
  },
};
</script>

<style scoped>
.login-page {
  text-align: center;
}
.login-page h1 {
  padding: 4rem 0;
  background-color: #0e1332;
  color: #fff;
}
.login-form {
  margin: 2rem auto;
  max-width: 30rem;
  padding: 2rem;
  border: 1px solid;
  border-radius: 4px;
}
.login-form h2 {
  padding-bottom: 2rem;
}
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  text-align: left;
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 800;
}
.form-group input {
  width: 100%;
  background-color: #e5e5e5;
  padding: 0.5rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.action-btn {
  margin: 2rem 0 1rem;
  display: flex;
}
.submit-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: 'Gothic';
}
.forgotlink {
  text-align: left;
}
.forgotlink a {
  text-decoration: none;
  color: #fff;
}
.forgotlink a:hover {
  text-decoration: underline;
}
</style>
